// ─── Cuan · index.js ──────────────────────────────────────────────────────────
// Only change from the original: wrap <App /> in <AuthProvider>.
// AuthProvider handles the login gate — no changes needed in App.js.

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
